export const PostData = (url = '', data , obj , callback) => {
    fetch(url,{
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: data
    }).then(response => {
        return response.text().then(text => {
            callback(obj,text);
        });
    }).catch(error => {
        if (error) {
            let errorR = {
                status: 'error-no-internet',
                data: {
                    message: 'اینترنت قطع می باشد'
                }
            }
            return callback(obj,JSON.stringify(errorR));
        }
    })
}


export const GetData = (url = '', obj , callback) => {
    fetch(url,{
        method: 'GET',
    }).then(response => {
        return response.text().then(text => {
            callback(obj,text);
        });
    }).catch(error => {
        let errorR = {
            status: 'error-no-internet',
            data: {
                message: 'اینترنت قطع می باشد'
            }
        }
        callback(obj,JSON.stringify(errorR));
    })
}

export const PostDataPromise = async (url = '', data) => {
    try {
        let token = "";
        let userdata = (localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {};
        if(userdata.API_TOKEN){
            token = userdata.API_TOKEN
        }
        let response = await fetch(url,{
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            },
            body: data
        });
        return await response.text();
    } catch(error) {
        if (error) {
            let errorR = {
                status: false,
                data: error
            }
            return JSON.stringify(errorR);
        }
    }
}
export const GetDataPromise = async (url = '', force = false) => {
    try {
        // singletonCache
        let data;
            if(!force){
            data = singletonCache.getItem(url);
            // console.log('pppppp   '  );
            // console.log(data);
            // console.log(url);
        }
        if(data){
            if(data.fetched){
                return data.data;
            }
            data = await retryFetch(url);
            if(data){
                return data.data;
            }
        }
        let token = "";
        let userdata = (localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {};
        if(userdata.API_TOKEN){
            token = userdata.API_TOKEN
        }
        let response = fetch(url,{
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                "Authorization": "Bearer " + token
            }
        });
        singletonCache.setItem(url, "", response, false);
        let responceText = await (await response).text();
        if(!(await response).ok){
            singletonCache.envalidateCache(url);

        } else {
            singletonCache.setItem(url, responceText, "", true);
        }

        return responceText;
    } catch(error) {
        console.log(error)
        if (error) {
            let errorR = {
                status: 'error-no-internet',
                data: {
                    message: 'اینترنت قطع می باشد'
                }
            }
            return JSON.stringify(errorR);
        }
    }
}


const retryFetch = async (url) => {
    return new Promise((resolve, reject) => {
        let item = singletonCache.getItem(url);
        if(!item){
            resolve();
        }
        if(item.fetched){
            resolve(item)
            return item;
        }
        setTimeout(() => {
            resolve(retryFetch(url))
        }, 30)
    })
}


let cacheStore = {};

const Cache = {
    getItem: (url) => {
        let item = cacheStore[url];
        if(!item){
            return;
        }
        if(item.timestamp < Date.now() - (5 * 60 * 1000)){
            return;
        }
        if(!item.fetched && item.timestamp < Date.now() - (3000)){
            return;
        }
        return item;
    },
    setItem: (url, data, promise, fetched = false) => {
        cacheStore[url] = {
            timestamp: Date.now(),
            data: data,
            promise: promise,
            fetched: fetched,
        }
    },
    envalidateCache: (url) => {
        let urls = Object.keys(cacheStore);
        let tobeDel = [];
        for (let i = 0; i < urls.length; i++) {
            const element = urls[i];
            if(element.search(url) !== -1 || element === url){
                tobeDel.push(element)
            }
        }
        // console.log(url, tobeDel, urls)
        for (let i = 0; i < tobeDel.length; i++) {
            const element = tobeDel[i];
            delete cacheStore[element]
        }
        // delete cacheStore[url]
    }
};

export const singletonCache = Object.freeze(Cache);